import React, { useState, useEffect, useRef } from 'react';
import { Check, Copy } from '@phosphor-icons/react';

export default function CopyableId({ value }) {
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    return () => { if (timeoutRef.current) clearTimeout(timeoutRef.current); };
  }, []);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => setCopied(false), 1500);
    } catch {}
  };

  return (
    <div className="copyable-id">
      <code className="copyable-id-code">{value}</code>
      <button
        className={`copyable-id-btn ${copied ? 'copied' : ''}`}
        onClick={handleCopy}
        title="Copy ID"
      >
        {copied ? (
          <Check size={14} />
        ) : (
          <Copy size={14} />
        )}
      </button>
    </div>
  );
}
